import { render } from "./VerHistoriaClinica.vue?vue&type=template&id=887e5b54&scoped=true"
import script from "./VerHistoriaClinica.vue?vue&type=script&lang=js"
export * from "./VerHistoriaClinica.vue?vue&type=script&lang=js"

import "./VerHistoriaClinica.vue?vue&type=style&index=0&id=887e5b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887e5b54"]])

export default __exports__